import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/r1/a/_Whimstay-travel-agent/src/components/frequently-asked-questions/FaqAccordion.tsx");
